import {
  AudienceDto,
  CreateExperienceDto,
  ExperienceDevicePreviewDto,
  ExperienceDto,
} from "@intelligems/ig-types";

import { ExperienceFe } from "../../../../types/schemas/experiences";
export const getExperienceDtoFromFe = (
  experience: ExperienceFe,
  productVariantCount?: number
): CreateExperienceDto => {
  return {
    id: experience.id,
    name: experience.name,
    isPreview: experience.isPreview,
    description: experience.description,
    devicePreview: experience.devicePreview,
    type: experience.type,
    category: experience.category,
    status: experience.status,
    testTypes: experience.testTypes,
    experienceAnalysis: experience.experienceAnalysis,
    experienceIntegrations: experience.experienceIntegrations,
    isExternal: experience.isExternal,
    shippingTestMethodDefinitions: experience.shippingTestMethodDefinitions,
    currency: experience.currency,
    pausedAtTs: experience.pausedAtTs,
    startedAtTs: experience.startedAtTs,
    endedAtTs: experience.endedAtTs,
    productVariantCount: productVariantCount || experience.productVariantCount,
    requiresLink: experience.requiresLink,
    linkBaseUrl: experience.linkBaseUrl,
  };
};

export const getExperienceFeFromDto = (
  experienceDto: ExperienceDto
): ExperienceFe => {
  return {
    ...experienceDto,
    shippingTestMethodDefinitions:
      experienceDto.shippingTestMethodDefinitions || [],
    devicePreview: getDevicePreviewFeFromDto(experienceDto.devicePreview),
    step: 0,
    viewMode: "edit",
    actionMode: "create",
    experienceAnalysis: experienceDto.experienceAnalysis,
    experienceIntegrations: experienceDto.experienceIntegrations,
  };
};

const getDevicePreviewFeFromDto = (
  devicePreview: ExperienceDevicePreviewDto | null | undefined
): ExperienceDevicePreviewDto => {
  return devicePreview || { device: "desktop", path: "/" };
};
